//
//
//
//
//
//
//
//
//
//
//
//
//

import CdnImageMixin from "./CdnImageMixin";
import AspectRatioBox from "../Layout/AspectRatioBox";

export default {
    name: "CdnBackgroundImage",
    components: {AspectRatioBox},
    mixins: [CdnImageMixin],

    props: {

        // Whether to center the image within the container
        center: {
            type: Boolean,
            default: true
        },

        // The gradient of the background image
        gradient: String,
    },

    computed: {
        // The srcset string for the image for responsiveness
        imageSrcSet() {
            return this.imageSrcSets.length ? this.imageSrcSets.map(srcSet => `url(${srcSet.url}) ${srcSet.dpr}x`).join(', ') : null;
        },

        imageStyle() {

            const style = {
                // Full width and height as the aspect ratio will hold the required space if the size is not forced
                width: '100%',
                height: '100%',
                backgroundRepeat: 'no-repeat',
            };

            if (this.immediate) {
                style.backgroundImage = [
                    `url(${this.imageSrc})`,
                    this.imageSrcSet ? `-webkit-image-set(${this.imageSrcSet})` : null, // Support Safari
                    this.imageSrcSet ? `image-set(${this.imageSrcSet})` : null
                ].filter(prop => !!prop);
            }

            if (this.cover) {
                style.backgroundSize = 'cover';
            }

            if (this.center) {
                style.backgroundPosition = 'center center';
            }

            if (this.blur) {
                style.filter = `blur(${this.blur}px)`;
            }

            return style;
        },

        gradientStyle() {
            const style = {};

            if (this.gradient) {
                style.backgroundImage = `linear-gradient(${this.gradient})`
            }

            return style;
        }
    },

    methods: {
        setImageSourcesOnImageElement() {
            if (this.$refs.image) {
                this.$refs.image.style.backgroundImage = `url(${this.imageSrc})`;
                // TODO: Add image-set
            }
        },
    }
}
